import React, { ReactNode  } from "react";
import styles from './EntityAddUpdateForm.module.css';

interface EntityAddUpdateFormProps {
  handleUserSubmit: (e: React.FormEvent) => void;
  handleCancel?: () => void; // Optional Cancel handler
  isUpdateActive?: boolean; // Make isUpdateActive optional
  children: ReactNode;
}

const EntityAddUpdateForm: React.FC<EntityAddUpdateFormProps> = ({
  handleUserSubmit,
  handleCancel,
  isUpdateActive,
  children,
}) => {

  return (
    <form onSubmit={handleUserSubmit} className={styles.entityAddUpdateForm}>
      <div className={styles.entityAddUpdateForm__inputBox}>{children}</div>
      <div className={styles.entityAddUpdateForm__BtnBox}>
        <button type="submit" className={styles.entityAddUpdateForm__submitbtn}>
          Submit
        </button>&nbsp;&nbsp;
        {isUpdateActive && handleCancel && (
          <button
            type="button"
            className={styles.entityAddUpdateForm__submitbtn}
            onClick={handleCancel}
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
};

export default EntityAddUpdateForm;